import React, { forwardRef, Ref, SyntheticEvent } from "react"

import { RichTreeView, TreeItem, TreeItemProps, useTreeItemModel } from "@mui/x-tree-view"
import { ExtendedTreeViewBase } from "../../../../hooks/useModelFamilyTree";

interface CustomLabelProps {
    children: string,
    className: string,
    count: number,
    color: string,
}


function CustomLabel({ children, className, count, color }: CustomLabelProps) {
    return (
        <div className={`${className} flex flex-row justify-start items-center gap-2`}>
            <div style={{ backgroundColor: color }} className="w-[10px] h-[10px] rounded-full shrink-0" />
            <p className="text-default font-medium">{children}</p>
            <div className="px-[8px] py-[0.5px] bg-[#CBCEDC]/[0.5] rounded-full">
                <p className='text-default font-medium text-[10px]'>{count}</p>
            </div>
        </div>
    )
}

const CustomTreeItem = forwardRef(function CustomTreeItem(
    props: TreeItemProps,
    ref: Ref<HTMLLIElement>,
) {
    const item = useTreeItemModel<ExtendedTreeViewBase>(props.itemId);

    return (
        <TreeItem 
            {...props}
            ref={ref}
            slots={{
                label: CustomLabel,
            }}
            slotProps={{
                label: { count: item?.count || '', color: item?.color ?? '' } as CustomLabelProps,
                content: {
                    style: {
                        marginBottom: 4,
                        padding: '4px 8px',
                    }
                },
                groupTransition: {
                    style: {
                        borderLeft: '1px dashed #9292AA',
                        marginLeft: 15,
                        paddingLeft: 8,
                    }
                }
            }}
        />
    )
})

export default function TreeView({
    treeItems,
    selectedItem,
    apiRef,
    expandedItems,
    handleExpandedItemsChange,
    handleSelectItemFromTree,
}: {
    treeItems: ExtendedTreeViewBase[],
    selectedItem: string | null,
    apiRef: any,
    expandedItems: string[],
    handleExpandedItemsChange: (event: SyntheticEvent | null, itemIds: string[]) => void,
    handleSelectItemFromTree: (e: React.SyntheticEvent<Element, Event> | null, id: string | null) => void,
}) {
    return (
        <RichTreeView 
            slotProps={{
                'collapseIcon': {
                    style: {
                        color: '#35424A',
                        width: '14px',
                    }
                },
                'expandIcon': {
                    style: {
                        color: '#35424A',
                        width: '14px',
                    }
                },
            }}
            slots={{ item: CustomTreeItem }}
            items={treeItems}
            apiRef={apiRef}
            expandedItems={expandedItems}
            onExpandedItemsChange={handleExpandedItemsChange}
            selectedItems={selectedItem}
            onSelectedItemsChange={handleSelectItemFromTree}
        />
    )
}